// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RatingCard-cls1___14e7b0173af18b9f1e0{/*!*/}.RatingCard-cls2___69fc38693ddca16022d{margin:0;color:#223;color:var(--Monochromatic-Black, #223);font-family:Roboto;font-size:14px;font-style:normal;font-weight:400;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RatingCard-cls1___14e7b0173af18b9f1e0",
	"cls2": "RatingCard-cls2___69fc38693ddca16022d RatingCard-cls1___14e7b0173af18b9f1e0"
};
export default ___CSS_LOADER_EXPORT___;
